import React from "react";
import { HELIOS_WORKFLOW } from "../../lib/living-demo";

export const HeliosWorkflow = ({ demo }) => {
  const ready = demo.phase === "ready";
  const engaged = ["requesting", "generating", "ready"].includes(demo.phase);
  return <ol className="helios-workflow" aria-label="Helios decision workflow" data-testid="helios-workflow">
    {HELIOS_WORKFLOW.map((label, index) => {
      const complete = index === 4 ? demo.approved : ready;
      const active = engaged && !complete && demo.workflowStage === index;
      return <li key={label} className={`${complete ? "complete" : ""} ${active ? "active" : ""}`} aria-current={active ? "step" : undefined} data-testid={`helios-workflow-step-${index}`}><span>0{index + 1}</span><div><strong>{label}</strong><small data-testid={`helios-workflow-state-${index}`}>{complete ? index === 4 ? "Demo review recorded" : "Ready to explore" : index === 4 && ready ? "Your review is required" : active ? "In progress" : ""}</small></div></li>;
    })}
  </ol>;
};